export const MaxSupportFileSizeInMB = 10;
export const MaxNumberOfSupportFiles = 5;
